import MCP from 'MCP';
import consolv from 'lib/consolv';

const defaults = {
	chicoryPassback: {
		enabled: false,
		elementId: 'chicory-aisle-slot',
		slotType: 'ad_responsive',
	},
};

function handleChicoryPassback(MCP: MCP, args: unknown[]) {
	consolv.log('MCP: Chicory slot passed back', args);

	const { chicoryPassback: configuration } = MCP.Configurator?.getConfiguration({ defaults });
	if (! configuration?.enabled) return;

	const chicoryAisleSlot = document.getElementById(configuration.elementId);
	if (!chicoryAisleSlot) return;

	chicoryAisleSlot.dataset.slotType = configuration.slotType;
	
	MCP.update(chicoryAisleSlot.parentElement!);
};

/**
 * Creates a GAM ad slot from unused Chicory aisle ad slots by listening for passback signals
 */
export default function chicoryPassbackHandler(MCP: MCP) {
	MCP.loaded.then(() => {
		const { chicoryPassback: configuration } = MCP.Configurator?.getConfiguration({ defaults });
		if (!configuration?.enabled) return;

		consolv.log('MCP: Chicory Passback Enabled');

		window.addEventListener( 'chicory_aisle_no_ads', (...args) => handleChicoryPassback(MCP, args));
	});
}
